import $ from "jquery";
import "slick-carousel";
import "@fortawesome/fontawesome-free";
import analyticView from "@bd-utils/analytic-view";
import idleTimer from "@bd-utils/idle-timer";
import broadcastInteraction from "@bd-utils/broadcast-interaction";
import broadcastScreenshot from "@bd-utils/broadcast-screenshot";
import * as pdfLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
pdfLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export const SmartTechPage = () => {
  if (!document.getElementById("media-carousel")) {
    return false;
  }

  var sliderState = "";

  const $elms = {
    main: $(".kiosksmart__main"),
    thumbnail: $(".kiosksmart__second-thumbnail-wrapper"),
    title: $(".kiosksmart__second-thumbnail-title-name-text"),
    desc: $(".kiosksmart__second-thumbnail-title-desc-text"),
    duration: $(".kiosksmart__second-thumbnail-title-duration"),
    videoPlayer: $("#video-player"),
    pdfCanvas: $("#pdf-canvas"),
    playBtnWrapper: $(".play-btn-container"),
    playBtn: $(".js-play-video"),
    arrowBtnPdfRight: $(".btn-right"),
    arrowBtnPdfLeft: $(".btn-left"),
    pageNum: $("#page-num"),
    pdfPageInfo: $("#page-info"),
    pdfPageCount: $("#page-count"),
    sliderPrev: $("#slider-prev"),
    sliderNext: $("#slider-next"),
    smartTechDoc: $("#smartTechDocument"),
    kioskNav: $("#kioskNavigation"),
  };

  $("#full-page").on("click", function () {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      $("#btn-full").removeClass("btn-shrink").addClass("btn-full");
    } else {
      $elms.smartTechDoc.get(0).requestFullscreen();
      $("#btn-full").removeClass("btn-full").addClass("btn-shrink");
    }
  });

  let vars = {
    pdfDoc: null,
    pageNum: 1,
    pageIsRendering: false,
    pageNumIsPending: null,
    scale: 1.5,
    ctx: $elms.pdfCanvas[0].getContext("2d"),
  };

  const init = () => {
    $("#media-carousel").slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      // prevArrow: $elms.sliderPrev,
      // nextArrow: $elms.sliderNext,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $("#media-carousel").on("wheel", function (e) {
      e.preventDefault();
      if (e.originalEvent.deltaY < 0) {
        $(this).slick("slickNext");
      } else {
        $(this).slick("slickPrev");
      }
    });

    const $firstChild = $(".kiosksmart__second-carousel-item").filter(
      '[data-index="0"]'
    );

    sliderState = 0;

    render($firstChild, false);

    const slideCount = $("#media-carousel").slick("getSlick").slideCount;

    if (slideCount <= 3) {
      setTimeout(function () {}, 500);
    }
  };

  const render = ($el, withAnalytic = true) => {
    const title = $el.attr("data-title");
    const desc = $el.attr("data-desc");
    const file = $el.attr("data-file");
    const type = $el.attr("data-format");
    const duration = $el.attr("data-length");
    let image = $el.attr("data-img");

    $elms.title.html(title);
    $elms.thumbnail.find("img").attr("src", image);
    $elms.desc.html(desc);

    $elms.videoPlayer[0].pause();

    switch (type) {
      case "video":
        setTimeout(function () {
          image = !image.includes("video-thumb") ? image : "";
          $elms.videoPlayer.attr("src", file);
          $elms.videoPlayer.attr("poster", image);
          $elms.videoPlayer[0].load();
        }, 300);

        if ($("#prev-page") || $("#next-page")) {
          $("#prev-page").addClass("hidden");
          $("#next-page").addClass("hidden");
        }

        $elms.duration.html(duration + " minutes");

        $elms.main.addClass("video-type").removeClass("document-type");
        break;

      case "pdf":
        if (vars.pdfDoc) {
          vars.pdfDoc.destroy();
        }
        vars.pageNum = 1;
        pdfLib
          .getDocument(file)
          .promise.then((_pdfDoc) => {
            vars.pdfDoc = _pdfDoc;
            var totalPages = _pdfDoc.numPages;
            $elms.pdfPageCount.text(vars.pdfDoc.numPages);

            setTimeout(function () {
              renderPdf(vars.pageNum);
            }, 300);

            if (totalPages > 1) {
              $("#prev-page").addClass("hidden");
              $("#next-page").removeClass("hidden");
            } else if (totalPages === 1) {
              $("#prev-page").addClass("hidden");
              $("#next-page").addClass("hidden");
            }
          })
          .catch((err) => {
            console.error(err);
          });

        document
          .querySelector("#prev-page")
          .addEventListener("click", showPrevPage);
        document
          .querySelector("#next-page")
          .addEventListener("click", showNextPage);

        $elms.duration.html(duration + " slides");

        $elms.main.addClass("document-type").removeClass("video-type");

        setTimeout(function () {
          if (withAnalytic) {
            analyticView("view-pdf", file);
          }
        }, 300);
        break;
    }
  };

  const renderPdf = (num) => {
    vars.pageIsRendering = true;

    vars.pdfDoc.getPage(num).then((page) => {
      const viewport = page.getViewport({ scale: vars.scale });
      $elms.pdfCanvas[0].height = viewport.height;
      $elms.pdfCanvas[0].width = viewport.width;

      const renderCtx = {
        canvasContext: vars.ctx,
        viewport,
      };

      page.render(renderCtx).promise.then(() => {
        vars.pageIsRendering = false;

        if (vars.pageNumIsPending !== null) {
          renderPdf(vars.pageNumIsPending);
          vars.pageNumIsPending = null;
        }
      });

      $elms.pageNum.text(num);
    });
  };

  const queueRenderPdf = (num) => {
    if (vars.pageIsRendering) {
      vars.pageNumIsPending = num;
    } else {
      renderPdf(num);
    }
  };

  const showPrevPage = () => {
    if (vars.pageNum <= 1) {
      return;
    }
    vars.pageNum--;
    queueRenderPdf(vars.pageNum);

    var pageCount = parseInt($elms.pdfPageCount[0].innerHTML);

    if (pageCount === 2) {
      $("#next-page").removeClass("hidden");
      $("#prev-page").addClass("hidden");
    } else if ($elms.pageNum[0].innerHTML === "2") {
      $("#prev-page").addClass("hidden");
    } else if ($elms.pageNum[0].innerHTML != "2") {
      $("#next-page").removeClass("hidden");
    }
  };

  const showNextPage = () => {
    if (vars.pageNum >= vars.pdfDoc.numPages) {
      return;
    }
    vars.pageNum++;
    queueRenderPdf(vars.pageNum);

    var pageCount = parseInt($elms.pdfPageCount[0].innerHTML);
    var pageInfo = parseInt($elms.pageNum[0].innerHTML);

    if (pageCount === 2) {
      $("#prev-page").removeClass("hidden");
      $("#next-page").addClass("hidden");
    } else if (pageCount === pageInfo + 1) {
      $("#next-page").addClass("hidden");
    } else if (pageCount != pageInfo + 1) {
      $("#prev-page").removeClass("hidden");
    }
  };

  $(document).on("click", ".kiosksmart__second-carousel-item", function () {
    render($(this));
    var pageIndex = $(".kiosksmart__main").attr("data-index");
    sliderState = $(this).parents(".slick-slide").index();

    if (+sliderState > pageIndex) {
      $(".kiosksmart__main")
        .removeClass("is-animating-prev")
        .addClass("is-animating-next");
      $(".kiosksmart__main").attr("data-index", sliderState);
    } else if (+sliderState < pageIndex) {
      $(".kiosksmart__main")
        .removeClass("is-animating-prev is-animating-next")
        .addClass("is-animating-prev");
      $(".kiosksmart__main").attr("data-index", sliderState);
    }

    setTimeout(function () {
      $(".kiosksmart__main").removeClass("is-animating-prev is-animating-next");
    }, 600);
  });

  $($elms.sliderNext).on("click", function () {
    var lastElm = $(".slick-track").children().last().attr("data-slick-index");
    var pageIndex = $(".kiosksmart__main").attr("data-index");

    if (sliderState == lastElm) {
      sliderState = 0;
    } else if (sliderState < lastElm) {
      sliderState = parseInt(sliderState) + 1;
    }

    if (+sliderState > pageIndex) {
      $(".kiosksmart__main")
        .removeClass("is-animating-prev")
        .addClass("is-animating-next");
      $(".kiosksmart__main").attr("data-index", sliderState);
    } else if (+sliderState < pageIndex) {
      if (sliderState === 0) {
        $(".kiosksmart__main")
          .removeClass("is-animating-prev is-animating-next")
          .addClass("is-animating-next");
      } else
        $(".kiosksmart__main")
          .removeClass("is-animating-prev is-animating-next")
          .addClass("is-animating-prev");
      $(".kiosksmart__main").attr("data-index", sliderState);
    }

    setTimeout(function () {
      $(".kiosksmart__main").removeClass("is-animating-prev is-animating-next");
    }, 600);

    var currentSlide = $(".slick-track")
      .children(".slick-slide")
      .filter(function () {
        return $(this).attr("data-slick-index") == sliderState;
      })
      .find(".kiosksmart__second-carousel-item");

    $("#media-carousel").slick("slickNext");

    render(currentSlide);
  });

  $($elms.sliderPrev).on("click", function () {
    var lastElm = $(".slick-track").children().last().attr("data-slick-index");
    var pageIndex = $(".kiosksmart__main").attr("data-index");

    if (sliderState === 0) {
      sliderState = lastElm;
    } else if (sliderState > 0) {
      sliderState = parseInt(sliderState) - 1;
    }

    if (+sliderState > pageIndex) {
      if (sliderState === lastElm) {
        $(".kiosksmart__main")
          .removeClass("is-animating-prev")
          .addClass("is-animating-prev");
      } else
        $(".kiosksmart__main")
          .removeClass("is-animating-prev")
          .addClass("is-animating-next");
      $(".kiosksmart__main").attr("data-index", sliderState);
    } else if (+sliderState < pageIndex) {
      $(".kiosksmart__main")
        .removeClass("is-animating-prev is-animating-next")
        .addClass("is-animating-prev");
      $(".kiosksmart__main").attr("data-index", sliderState);
    }

    setTimeout(function () {
      $(".kiosksmart__main").removeClass("is-animating-prev is-animating-next");
    }, 600);

    var currentSlide = $(".slick-track")
      .children(".slick-slide")
      .filter(function () {
        return $(this).attr("data-slick-index") == sliderState;
      })
      .find(".kiosksmart__second-carousel-item");

    $("#media-carousel").slick("slickPrev");

    render(currentSlide);
  });

  $elms.playBtn.on("click", function () {
    $elms.videoPlayer[0].play();
  });

  $elms.videoPlayer.on("play", function () {
    $elms.playBtnWrapper.addClass("translucent");

    if ($elms.videoPlayer[0].currentTime < 1) {
      analyticView("play-video", $elms.videoPlayer.attr("src"));
    }
  });

  $elms.videoPlayer.on("pause", function () {
    $elms.playBtnWrapper.removeClass("translucent");
  });

  // on idle timeout reset page state
  const onIdleTimeout = () => {
    const $firstSlide = $('.slick-slide[data-slick-index="0"]');
    if (
      $(".kiosksmart__second-thumbnail-title-name-text").text().trim() ==
      $firstSlide
        .find(".kiosksmart__second-carousel-item-name-text")
        .text()
        .trim()
    ) {
      return;
    }

    $(".slick-slider").slick("slickGoTo", 0);
    sliderState = 0;
    render($firstSlide.find(".kiosksmart__second-carousel-item"), false);
  };

  document.addEventListener("selectstart", function (event) {
    event.preventDefault();
  });

  document.addEventListener(
    "contextmenu",
    function (e) {
      e.preventDefault();
    },
    false
  );

  init();
  idleTimer(onIdleTimeout);
  broadcastInteraction();
  broadcastScreenshot();
};
